import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'enumToArray' })
export class EnumToArrayPipe implements PipeTransform {
  transform(value: { [x: string]: any; }, filter?: { notShow: string[] }): object {

    // gösterilmesini istemediğimiz parametreleri göstermiyoruz.
    const notShow = filter?.notShow ? filter?.notShow : [];

    return Object.keys(value).filter(e => {
      return !isNaN(+e) && notShow.indexOf(e) < 0;
    }).map(o => ({ value: +o, label: value[o] }));
  }
}
